export default {
  slug: "dentures-in-guwahati",
  title: "Dentures in Guwahati",
  subtitle:
    "Custom-made, comfortable, and natural-looking dentures to regain confidence and function",
  heroImage: "/dental-services/dentures/best-teeth-replacement-guwahati.webp",

  sections: [
    {
      type: "text",
      heading: "Dentures in Guwahati – Restore Your Smile at Magnum Dental Clinic, Guwahati",
      content: `
Missing teeth can affect not just your smile, but also your confidence, speech, and ability to chew properly. At Magnum Dental Clinic, Guwahati, we provide custom-made, comfortable, and natural-looking dentures that help you regain a healthy and confident smile.

Whether you are missing a few teeth or an entire set, our expert dentists design dentures that fit well, function naturally, and enhance facial aesthetics.
      `,
    },
    {
      type: "image",
      images: [
        "/dental-services/dentures1.webp",
        "/dental-services/dentures/best-dentures-in-guwahati.webp",
        "/dental-services/dentures/dentures-in-guwahati.webp",
        "/dental-services/dentures/teeth-replacement-in-guwahati.webp",
      ],
      caption: "Images are for illustrative  purposes only",
    },
    {
      type: "text",
      heading: "What Are Dentures?",
      content: `
Dentures are removable prosthetic devices used to replace missing teeth and surrounding tissues. They are custom-fabricated to match your facial structure, gum shape, and natural tooth color, ensuring a comfortable fit and realistic appearance.

Dentures help you:
✔ Eat and chew comfortably  
✔ Speak clearly  
✔ Prevent facial sagging caused by tooth loss  
✔ Improve overall oral health  
✔ Smile with confidence again
      `,
    },

    {
  type: "text",
  heading: "Types of Dentures we offer",
  content: `
**Complete Dentures**
Ideal for patients who have lost all teeth in the upper or lower jaw. These dentures rest on the gums and restore full oral function and appearance.

**Partial Dentures**
Recommended when some natural teeth remain. Partial dentures fill the gaps and are supported by remaining teeth, preventing them from shifting.

**Flexible Dentures**
Made from lightweight, flexible material for better comfort and aesthetics. These dentures blend naturally with gums and are easy to wear.

**Implant-Supported Dentures**
Anchored securely using dental implants, these dentures offer maximum stability, improved chewing power, and long-term durability.
  `,
},

    {
      type: "text",
      heading: "Why Choose Dentures from Magnum Dental Clinic?",
      content: `
✔ Experienced dentists with personalized care  
✔ High-quality, durable denture materials  
✔ Natural look and comfortable fit  
✔ Advanced diagnostic and treatment techniques  
✔ Affordable denture treatment in Guwahati  
✔ Hygienic, modern, and patient-friendly clinic

We focus on precision, comfort, and long-term results for every patient.
      `,
    },

    {
      type: "text",
      heading: "The Denture Treatment Process",
      content: `
1. Consultation & Oral Examination  
2. Measurements & Impressions  
3. Customized Denture Design  
4. Trial Fitting for Accuracy & Comfort  
5. Final Denture Placement & Adjustments

Our team ensures your dentures feel natural and function effectively before final placement.
      `,
    },

    {
      type: "text",
      heading: "How to Care for Your Dentures",
      content: `
➤ Clean dentures daily using a soft brush  
➤ Avoid harsh or abrasive cleaners  
➤ Remove dentures at night to rest gums  
➤ Soak dentures in recommended solution  
➤ Visit the dentist regularly for adjustments

Proper care helps dentures last longer and keeps your mouth healthy.
      `,
    },
  ],

  faqs: [
    {
      q: "Are dentures uncomfortable?",
      a: "Modern dentures are designed for comfort. Some adjustment time is normal, but they should not cause pain.",
    },
    {
      q: "How long do dentures last?",
      a: "With proper care, dentures typically last 5–10 years, though adjustments may be needed over time.",
    },
    {
      q: "Can I eat normally with dentures?",
      a: "Yes. After a short adjustment period, you can enjoy most foods comfortably.",
    },
    {
      q: "How long does it take to get dentures?",
      a: "The complete process usually takes 2–4 weeks, depending on the type of denture.",
    },
    {
      q: "Are dentures affordable in Guwahati?",
      a: "Yes. Magnum Dental Clinic offers cost-effective denture solutions without compromising quality.",
    },
  ],

  cta: {
    heading: "Book Your Denture Consultation in Guwahati",
    description: `
If you’re looking for reliable denture treatment in Guwahati, trust the expertise at Magnum Dental Clinic. We are committed to restoring your smile with comfort, care, and confidence.

📍 Location: First Floor, Global Tower, Near Mangalam Grand, Pathar Quarry, VIP Road, Guwahati, Assam

📞 Call at 8638940021 to book your appointment
    `,
    buttonText: "Book Denture Consultation",
    link: "/book-appointment-dental-clinic-guwahati",
  },
};
